// import { HttpService } from '../http.service';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Component({
  template: ''
})
export class CountrySelect implements OnDestroy {

    countries: any;
    subs: Subscription[] = [];

    countryCode: string;
    stateCode: string;
    representatives = [];
    reps: any;

    repjson: any;
    states: any;
    international: any;

    constructor(
      // public _httpService: HttpService,
      private _http: HttpClient,
      ) {
    }

    getReps() {
      console.log(this.repjson);
      if(!this.repjson || this.repjson.length < 1 || this.repjson == undefined){
        this.subs.push(this._http.get('https://www.veexinc.com/reps/load.php?json=1').subscribe((data) => {
          // console.log(data);
          this.repjson = data;
          this.states = data['USA'];
          this.international = data['Intl'];
          console.log(this.repjson);
        }));
      }
      // console.log(this.repjson);
    }

  chooseCountry(): void {
    this.representatives = [];
    if (this.countryCode === 'USA' || this.countryCode === 'United States (USA)') {
      this.representatives = [];
      // console.log('USA!!')
      this.searchArrayofObjects(this.countryCode, this.international);
      // const element = document.getElementById('stateselect');
      // element.className = 'show';
    } else {
      this.representatives = [];
      // const element = document.getElementById('stateselect');
      // element.className = 'collapse';
      // const element1 = document.getElementById('partner');
      // element1.className = 'show vx-section-header h4';
      // console.log(this.countryCode);
      this.searchArrayofObjects(this.countryCode, this.international);
      // console.log(this.reps);
    }
  }

  chooseState(): void {
    this.representatives = [];
    // const element1 = document.getElementById('partner');
    // element1.className = 'show vx-section-header h4';
    // let element = document.getElementById('USlocation');
    // element.className = 'd-block text-center lead mb-0 px-3 blue';
    this.searchArrayofObjects(this.stateCode, this.states);
    // console.log(this.reps);
  }

  searchArrayofObjects(key: string, arr: string | any[]): void {
    // let count = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].Countries === key) {
        let temparr = [];
        if(arr[i].LocalContactWebsite){
          if(arr[i].LocalContactWebsite.includes('  /  ')){
            temparr = arr[i].LocalContactWebsite.split('  /  ');
            console.log(temparr);
            
          } else {
            temparr.push(arr[i].LocalContactWebsite);
          }
          arr[i].LocalContactWebsite = temparr;
        }
        this.representatives.push(arr[i]);
      }
    }
    if (this.representatives.length === 0) {
      this.repjson.manrep[0]['LocalContactWebsite'] = [this.repjson.manrep[0]['LocalContactWebsite']];
      this.representatives = [this.repjson.manrep[0]];
    }
    this.reps = this.representatives;
    console.log(this.reps, this.reps[0].LocalContactWebsite);
  }

  hidecontactinfo(idcount: string): void {
    if (this.representatives[idcount].LocalContactEmail === '') {
      const element = document.getElementById('repemail' + idcount);
      element.className = 'collapse';
    }
    if (this.representatives[idcount].LocalContactWebsite === '') {
      const element = document.getElementById('repwebsite' + idcount);
      element.className = 'collapse';
    }
  }

    ngOnDestroy(): void {
      this.subs.forEach((sub) => {
          sub.unsubscribe();
      });
    }
}
